import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { UserService } from '../services/users/user.service';

import { ProviderService } from '../services/providers/provider.service';
import { specialties } from './specialties.component'
import * as _ from 'lodash';

@Component({
    moduleId: module.id,
    selector: 'my-users',
    template: ``
})

export class UsersComponent implements OnInit {

    protected createCalled: boolean = false;
    protected deleteCalled: boolean = false;

    newUser: any = {};
    users: any[];
    selectedUser: any;
    loading: boolean = false;

    byName: boolean = true
    byEmail: boolean = false
    byDate: boolean = false
    specialty: boolean = false
    notLogged: boolean = true;
    term: string = ""
    findOptions: string = "name"

    selectedSpecialty: any = {
        name: ""
    }

    fromDate: Date;
    toDate: Date
    from: string
    to: string

    specialtiesArray = specialties;

    providers: any[]
    provider: any = {
        name: ""
    }

    firstUsers: any[] = []

    //TABLE
    usersToShow: any[] = [];
    finalUsers: any[] = []

    pages: number;
    usersPerPage = 50;
    usersPerGet = 50;
    currentPage = 0;
    pagesArray: any[] = [];
    timesSkipped = 0;
    haveUsers: boolean = true;
    empty: boolean = false;
    //TABLE

    // PAGINATION
    currentFilter: any = {}

    constructor(
        protected router: Router,
        protected userService: UserService,
        protected providerSevice: ProviderService) { }

    protected getDetailUrl(): string { return; };
    protected getCallDetailUrl(): string { return; };
    protected getUserString(): string { return; };
    protected getUsersString(): string { return; };
    protected createdAt(users: any[]) { };

    alertAdd: boolean = false;
    alertCreated: boolean = false;
    alertDate: boolean = false;
    noMatchesAlert: boolean = false;
    closeNoMatchesAlert() {
        this.noMatchesAlert = false;
    }
    closeAddAlert() {
        this.alertAdd = false;
    }
    closeCreatedAlert() {
        this.alertCreated = false;
    }
    closeDateAlert() {
        this.alertDate = false;
    }

    ngOnInit(): void {
        this.getProviders()
    }

    getProviders() {
        this.providerSevice.get().then((providers) => {
            this.providers = providers
        })
    }

    setUsers(users) {
        this.users = users
        this.createdAt(this.users)
        this.haveUsers = this.users.length === this.usersPerGet
        this.noMatchesAlert = this.users.length === 0
        this.configPages();
        this.loading = false;
        this.timesSkipped++;
    }

    getUsers(params) {
        this.userService.get(params)
            .then(users => { this.setUsers(users) } )
    }

    getUsersWithFilter(filter) {
        this.currentFilter = filter;
        this.timesSkipped = 0;
        this.currentPage = 0;
        this.getUsers(_.merge(filter, { limit: this.usersPerGet }));
    }

    reset() {
        this.loading = true;
        this.byDate = false;
        this.byEmail = false;
        this.specialty = false;
        this.byName = true;
        this.notLogged = true
        this.users = []
        this.timesSkipped = 0
        this.getUsers({ limit: this.usersPerGet })
        this.currentPage = 0
        this.term = undefined
        this.alertAdd = false;
        this.alertCreated = false;
        this.alertDate = false;
        this.noMatchesAlert = false;
    }

    logged() {
        this.loading = true;
        this.timesSkipped = 0;
        this.currentPage = 0
        this.users = []
        this.needMoreUsers({limit: this.usersPerGet });
        this.loading = false
    }

    configPages(): void {
        this.pages = ((this.users.length / this.usersPerPage) >> 0); //Para que me quede un numero entero
        if ((this.pages * this.usersPerPage) < this.users.length) {
            this.pages++;
        }
        this.usersToShow = this.users.slice(this.currentPage, this.usersPerPage);
        this.pagesArray = [] //have to restart it
        for (let i = 0; i < this.pages; i++) {
            this.pagesArray.push({ n: i });
        }
    }

    setPage(page: number) {
        this.currentPage = page;
        this.changePage();
    }
    backPage() {
        if (this.currentPage == 0) {
            return;
        }
        this.currentPage--;
        this.changePage();
    }
    nextPage() {
        if (this.currentPage >= (this.pages - 1)) {
            if (this.haveUsers) {
                this.needMoreUsers({ skip: this.usersPerGet * this.timesSkipped, limit: this.usersPerGet }, () => {
                    this.currentPage++;
                    this.changePage();
                } );
            }
        } else {
            this.currentPage++;
            this.changePage();
        }
    }

    changePage(): void {
        let inicio = this.currentPage * this.usersPerPage;
        this.usersToShow = this.users.slice(inicio, inicio + this.usersPerPage)
    }

    needMoreUsers(params, readyCb : any = null) {
        params = _.merge(this.currentFilter, params);

        console.log(params)

        if (this.provider.name != "") params['provider'] = this.provider.id
        params[this.findOptions] = this.term
        params['limit'] = this.usersPerGet;

        if (!this.notLogged) params.loggedIn = true;

        this.timesSkipped++;
        let i = 0;
        this.userService.get(params)
            .then(users => {
                this.haveUsers = users.length === this.usersPerGet
                if (0 < users.length) {
                    this.createdAt(users)
                    for (i; i < users.length; i++) {
                        this.users.push(users[i])
                    }
                    this.noMatchesAlert = users.length === 0
                    this.configPages();
                }
                if (readyCb) readyCb();
            })
    }

    compare(a, b): number {
        let nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
    }

    pushOrdered(user: any) {
        for (let i = 0; i < this.users.length; i++) {
            if (user.name.toLowerCase() < this.users[i].name.toLowerCase()) {
                this.users.splice(i, 0, user)
                return
            }
        }
        this.users.push(user)
    }

    morePages() {
        if (this.haveUsers) {
            let params = { skip: this.usersPerGet * this.timesSkipped, limit: this.usersPerGet }
            this.needMoreUsers(params);
        }
    }

    onSelect(user: any): void {
        this.selectedUser = user;
        this.gotoDetail();
    }

    onSelectCall(user: any): void {
        this.selectedUser = user;
        this.gotoCallDetail();
    }

    gotoDetail(): void {
        window.open(window.location.origin+this.getDetailUrl());
    }
    gotoCallDetail(): void {
        window.open(window.location.origin+this.getCallDetailUrl());
    }

    add(): void {
        return;
    }

    delete(user: any): void {
        if (!confirm("Sure you want to delete the user? " + user.name)) return;

        if (this.deleteCalled) {

            return;
        }

        this.deleteCalled = true;

        this.userService
            .delete(user.id)
            .then(() => {

                this.users = this.users.filter(u => u !== user);
                if (this.selectedUser === user) {

                    this.selectedUser = null;
                }

                this.deleteCalled = false;
                this.configPages()
            })
            .catch(error => {

                this.deleteCalled = false;
                return Promise.reject(error.message || error);
            });
    }

    getDate(date: Date): string {
        let dateParts: number[] = []
        let fecha: string = '';
        let i;
        for (i = 0; i < 10; i++) {
            if (date[i] == '-') {
                dateParts.push(Number(fecha))
                fecha = '';
            }
            else fecha += date[i]
        }
        dateParts.push(Number(fecha))

        let day = dateParts[2].toString()
        let month = dateParts[1].toString()
        if (day.length == 1) day = '0' + day;
        if (month.length == 1) month = '0' + month;
        return day + '-' + month + '-' + dateParts[0]
    }

    filter(): boolean {

        if (this.fromDate == undefined || this.toDate == undefined) {
            this.alertDate = true;
            return;
        }
        this.alertDate = false;
        this.loading = true;
        this.from = this.getDate(this.fromDate)
        this.to = this.getDate(this.toDate)
        this.timesSkipped = 0;
        this.currentPage = 0
        return true;
    }

    searchDate() {
        if (!this.filter()) return;
        this.noMatchesAlert = false;
        this.currentPage = 0
        let params;
        if (!this.notLogged) params = { from: this.from, to: this.to, limit: this.usersPerGet, loggedIn: true }
        else params = { from: this.from, to: this.to, limit: this.usersPerGet }

        this.userService.get(params).then((users: any[]) => this.users = users)
            .then(() => {
                this.loading = false;
                this.haveUsers = this.users.length === this.usersPerGet
                this.configPages()
                this.createdAt(this.users)
                this.noMatchesAlert = this.users.length === 0
            })
        this.timesSkipped = 0;
    }
    search(): void {
        if (this.term == undefined /*|| this.term == ''*/) return
        this.noMatchesAlert = false;

        this.currentPage = 0
        this.loading = true;
        let params = {};
        if (this.provider.name != "") params['provider'] = this.provider.id
        params[this.findOptions] = encodeURIComponent(this.term)
        params['limit'] = this.usersPerGet;
        if (!this.notLogged) params['loggedIn'] = true;

        console.log(params)

        this.userService.get(params).then((users: any[]) => this.users = users)
            .then(() => {

                this.haveUsers = this.users.length === this.usersPerGet
                this.loading = false;
                this.configPages()
                this.createdAt(this.users)
                this.timesSkipped = 1;
                this.noMatchesAlert = this.users.length === 0;
            })


    }

    selectProvider(provider) {
        this.provider = provider
    }
    selectSpecialty(spec) {
        this.selectedSpecialty = spec
        this.term = this.selectedSpecialty.id
        console.log(this.term)
    }
}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts